import { render, staticRenderFns } from "./ScholarshipMappingList.vue?vue&type=template&id=295d50c6"
import script from "./ScholarshipMappingList.vue?vue&type=script&lang=js"
export * from "./ScholarshipMappingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports